module.exports = __webpack_public_path__ + "static/media/volleyball.5ea96ad4.png";